import { Button, Card, Col, Row, Select, Typography, Image } from "antd";
import { StyleSheet } from "../../StyleSheet";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import InfoCardComponent from "../../components/InfoCardComponent";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { Key, useCallback, useEffect, useState } from "react";
import _ from "lodash";
import {
  downloadPdfStatement,
  getAccountStatements,
  getBillingData,
  getBillingPDF,
  getInvoiceData,
  getPaymentDataFlp,
  sendStatementBySms,
} from "../../methods/Methods";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import SendSMS from "./SendSMS";
import { saveFile } from "../../assets/mexicoStates/SaveFile";
import {
  AlertSliceInterface,
  clearAlert,
  setAlert,
  showAlert,
} from "../../stores/slices/alertSlice";
import { AppDispatch } from "../../stores/store";
import {
  Datos,
  RequestSendSmsEdocta,
  ResponseGetListaFacturasFactura,
} from "../../types/common";
import { images } from "../../routes/ImageRoutes";
import appProps from "../../AppConfigContext";
import { cifrarAES } from "../../assets/Encrypt";
const { Text } = Typography;

interface SelectedOpt {
  value: string;
  label: string;
}

const AccountState = () => {
  const [sendSMS, setSendSMS] = useState<boolean>(false);
  const [selectedPeriod, setSelectedPeriod] = useState<string>("");
  const generalData = useSelector(getGeneralData);
  const [idCliente, setIdCliente] = useState<string>("");
  const [fullName, setFullName] = useState<string>("");
  const [nombre, setNombre] = useState<string>("");
  const [unavailableInfo, setUnavailableInfo] = useState<boolean>(false);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [status, setStatus] = useState<boolean>(false);
  const [hasError, setHasError] = useState(false);
  const [statesAccounts, setStateAccounts] = useState<Array<SelectedOpt>>([]);
  const [hasBilling, setHasBilling] = useState(false);
  const [billings, setBillings] = useState<ResponseGetListaFacturasFactura[]>([]);
  const [processStatement, setProcessStatement] = useState("");
  const [selectedDate, setSelectedDate] = useState<SelectedOpt>();
  const navigate = useNavigate();
  const [canDownloadBillingPDF, setCanDownloadBillingPDF] = useState<boolean>(false);
  const [billingMatched, setBillingMatched] = useState<ResponseGetListaFacturasFactura>();
  const dispatch = useDispatch<AppDispatch>();
  const [paymentData, setPaymentData] = useState<Datos>();
  const [imageUrl, setImageUrl] = useState("");
  const [fullDateFormat, setFullDateFormat] = useState("");

  const fetchData = useCallback(async () => {
    setSelectedPeriod("");
    setIsLoading(true);

    let billings: ResponseGetListaFacturasFactura[] = [];
    let statesAccounts: SelectedOpt[] = [];
    let hasBilling: boolean = false;
    let datos: Datos | undefined = undefined;

    // Facturas
    await getBillingData(idCliente)
      .then((response) => {
        if (response.data && response.data.data[0].facturas) {
          billings = response.data.data[0].facturas;
        } else {
          setBillings([]);
        }
      })
      .catch(() => {
        setBillings([]);
      });

    // Estados de cuenta
    await getAccountStatements(idCliente)
      .then((response) => {
        if (response.data.data[0].estados && !_.isEmpty(response.data.data[0].estados)) {
          response.data.data[0].estados.forEach((estado) => {
            let stateAccountObject = {
              value: estado.proceso,
              label: estado.mes,
            };
            statesAccounts.push(stateAccountObject);
          });
        } else {
          setMessage("No hay información para mostrar.");
        }
      })
      .catch(() => {
        setHasError(true);
        setMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.");
      });

    // Obtener los datos de facturacion
    await getInvoiceData(idCliente)
      .then((response) => {
        if (response && response.data && response.data.data[0] && !_.has(response.data.data[0], 'estatus')) {
          hasBilling = true;
        } else {
          hasBilling = false;
        }
      })
      .catch(() => {
        hasBilling = false;
      });

    let status: boolean = false;
    await getPaymentDataFlp(idCliente)
      .then((response) => {
        // Se pregunta si la respuesta no está vacía.
        if (response.data.data[0].data.mensaje) {
          setMessage(response.data.data[0].data.mensaje);
          setUnavailableInfo(true);
        } else {
          datos = response.data.data[0].data.datos;
          status =
            response.data.data[0].data?.datos?.amount !== undefined &&
              parseFloat(response.data.data[0].data.datos.amount) > 0
              ? true
              : false;
          if (datos) {
            let fullDateFormat = "";
            const [diaStr, mesStr,] = datos.paymentLimitDate.split("-");

            const mesMap: Record<string, string> = {
              Ene: "Enero",
              Feb: "Febrero",
              Mar: "Marzo",
              Abr: "Abril",
              May: "Mayo",
              Jun: "Junio",
              Jul: "Julio",
              Ago: "Agosto",
              Sep: "Septiembre",
              Oct: "Octubre",
              Nov: "Noviembre",
              Dic: "Diciembre",
            };

            const monthLong = mesMap[mesStr];
            const day = parseInt(diaStr, 10);

            fullDateFormat = `${day} de ${monthLong}`;
            setFullDateFormat(fullDateFormat);

          }
        }
      })
      .catch(() => {
        setMessage(
          "Hubo un error al procesar su solicitud. \nIntente más tarde."
        );
        setUnavailableInfo(true);
      });

    setTimeout(() => {
      setIdCliente(idCliente);
      setNombre(fullName);
      // Facturas
      setBillings(billings);
      // Estados de cuenta
      setStateAccounts(statesAccounts);
      // Datos de facturacion
      setHasBilling(hasBilling);
      setStatus(status);
      setPaymentData(datos);
      setIsLoading(false);
    }, 500);
  }, [idCliente, fullName]);

  const handleDateSelection = (
    selectedItem:
      | { value: Key; label: string }
      | { value: Key; label: string }[]
  ) => {
    const selectedOptions = Array.isArray(selectedItem)
      ? selectedItem
      : [selectedItem];
    selectedOptions.forEach((selectedOption) => {
      if (selectedOption && selectedOption.value) {
        const selectedValue = selectedOption.value.toString();
        setSelectedPeriod(selectedValue);
        setSelectedDate({ value: selectedValue, label: selectedOption.label });
        setProcessStatement(selectedValue);

        const billingMatched2 = billings.find((billing: any) => {
          const date = new Date(billing.fecha);
          if (date) {
            let proccess: string = date.getFullYear().toString().slice(2, 4);
            proccess +=
              date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1;

            return proccess === selectedOption.value.toString().slice(0, 4);
          }
          return false;
        });

        setBillingMatched(billingMatched2);
      }
    });
  };

  const handleSendSMS = () => {
    setSendSMS(true);
  };

  const downloadStatement = async (element: string) => {
    let pdfFile = "";
    let objStatement = {
      proceso: element,
    };

    setIsLoading(true);

    await downloadPdfStatement(objStatement, idCliente)
      .then((response) => {
        if (response && response.data && response.data.data[0] && _.isEqual(response.data.data[0].estatus, "Exito")) {
          pdfFile = response.data.data[0].archivo;
        }
        setIsLoading(false);
      })
      .catch(() => {
        let dispatchAlert: AlertSliceInterface = {
          show: true,
          type: "ERROR",
          title: "¡Estimado Usuario!",
          message: "No fue posible obtener el estado de cuenta. Intentelo más tarde",
          onFinalize: () => handleDispatchAlertModal(),
        };
        openAlertModal(dispatchAlert);
        setIsLoading(false);
      });

    if (pdfFile !== "" && element !== "") {
      downloadAccountStatementPDF(pdfFile, element);
    } else {
      let dispatchAlert: AlertSliceInterface = {
        show: true,
        type: "ERROR",
        title: "¡Estimado Usuario!",
        message: "No fue posible obtener el estado de cuenta. Intentelo más tarde",
        onFinalize: () => handleDispatchAlertModal(),
      };
      openAlertModal(dispatchAlert);
    }
  };

  const downloadAccountStatementPDF = async (
    pdfFile: string,
    proceso: string
  ) => {
    saveFile(pdfFile, "application/pdf", `EdoCuenta_${proceso}.pdf`);
    let dispatchAlert: AlertSliceInterface = {
      show: true,
      type: "SUCCESS",
      title: "¡Estimado Usuario!",
      message: "¡Su estado de cuenta se ha descargado con éxito!",
      onFinalize: () => handleDispatchAlertModal(),
    };
    openAlertModal(dispatchAlert);
  };

  const getBillingPDFFunction = async (element: {
    fecha: string;
    emisor: string;
    serie: string;
    folio: string;
  }) => {
    let billingPDF: string = "";
    const searchBillingMatched = billings.find((billing: any) => {
      const dateElement = new Date(element.fecha);
      const dateBilling = new Date(billing.fecha);

      // Comparar las fechas
      return dateElement.getTime() === dateBilling.getTime();
    });

    if (searchBillingMatched) {
      await getBillingPDF(
        searchBillingMatched.emisor,
        searchBillingMatched.serie,
        searchBillingMatched.folio
      )
        .then((response) => {
          // Se pregunta si hay una respuesta y la respuesta no está vacía.
          if (response.data && response.data.data[0]) {
            // Se setean los datos necesarios
            billingPDF = response.data.data[0]?.archivo;
          }
        })
        .catch(() => {
          let dispatchAlert: AlertSliceInterface = {
            show: true,
            type: "ERROR",
            title: "¡Estimado Usuario!",
            message: "No fue posible obtener la factura. Intentelo más tarde.",
            onFinalize: () => handleDispatchAlertModal(),
          };
          openAlertModal(dispatchAlert);
        });
      // Se pregunta si el PDF contiene algo.
      if (billingPDF !== "" && !_.isEmpty(searchBillingMatched.folio)) {
        downloadAccountInvoicePDF(billingPDF, searchBillingMatched.folio);
      } else {
        let dispatchAlert: AlertSliceInterface = {
          show: true,
          type: "ERROR",
          title: "¡Estimado Usuario!",
          message: "No fue posible obtener la factura. Intentelo más tarde.",
          onFinalize: () => handleDispatchAlertModal(),
        };
        openAlertModal(dispatchAlert);
      }
    }
  };

  const downloadAccountInvoicePDF = async (pdf: string, folio: string) => {
    if (pdf && folio) {
      saveFile(pdf, "application/pdf", `factura_${folio}.pdf`);
      let dispatchAlert: AlertSliceInterface = {
        show: true,
        type: "SUCCESS",
        title: "¡Estimado Usuario!",
        message: "¡Su factura se ha descargado con éxito!",
        onFinalize: () => handleDispatchAlertModal(),
      };
      openAlertModal(dispatchAlert);
    }
  };

  const sendSmsFnt = async (objSMS: RequestSendSmsEdocta) => {
    let typeAlert = "";
    let messageAlert = "";
    setIsLoading(true);
    await sendStatementBySms(objSMS, idCliente)
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.data[0] &&
          response.data.data[0].resultado === "true"
        ) {
          typeAlert = "SUCCESS";
          messageAlert =
            "Se ha enviado un SMS\n" +
            objSMS.celular +
            "\nCon el estado de cuenta\n" +
            nombre +
            "\n" +
            idCliente;
        } else {
          typeAlert = "ERROR";
          messageAlert =
            "Hubo un error al procesar su solicitud. \nIntente más tarde.";
        }
        let dispatchAlert: AlertSliceInterface = {
          show: true,
          type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
          title: "¡Estimado Usuario!",
          message: messageAlert,
          onFinalize: () => handleDispatchAlertModal(),
        };
        openAlertModal(dispatchAlert);
        setIsLoading(false);
      })
      .catch(() => {
        let dispatchAlert: AlertSliceInterface = {
          show: true,
          type: "ERROR",
          title: "¡Estimado Usuario!",
          message:
            "Hubo un error al procesar su solicitud. \nIntente más tarde.",
          onFinalize: () => handleDispatchAlertModal(),
        };
        openAlertModal(dispatchAlert);
        setIsLoading(false);
      });
  };

  const handleDispatchAlertModal = useCallback(() => {
    dispatch(showAlert(false));
    dispatch(clearAlert());
  }, [dispatch]);

  const openAlertModal = useCallback(
    (option: AlertSliceInterface) => {
      dispatch(
        setAlert({
          show: true,
          type: option.type as "INFO" | "SUCCESS" | "ERROR",
          title: option.title,
          message: option.message,
          onFinalize: option.onFinalize,
        })
      );
    }, [dispatch]
  );

  useEffect(() => {
    if (generalData.selectedContract !== null) {
      setIdCliente(
        generalData.selectedContract.sucursal +
        generalData.selectedContract.suscriptor
      );
      setFullName(
        generalData.selectedContract.nombre +
        " " +
        generalData.selectedContract.apellidoPaterno +
        " " +
        generalData.selectedContract.apellidoMaterno
      );
    }
  }, [generalData.selectedContract]);

  useEffect(() => {
    if (!_.isEmpty(idCliente)) {
      fetchData();
    }
  }, [idCliente, fetchData]);

  useEffect(() => {
    if (billings.length > 0) {
      setCanDownloadBillingPDF(true);
    }
  }, [billings]);

  useEffect(() => {
    if (statesAccounts && statesAccounts.length > 0) {
      setProcessStatement(statesAccounts[0].value.toString());
      let selectedObject = {
        value: statesAccounts[0].value,
        label: statesAccounts[0].label,
      };
      setSelectedDate(selectedObject);
    }

    if (billings && billings.length > 0 && statesAccounts[0] && statesAccounts[0].value) {
      const billingMatched1 = billings.find((billing) => {
        let date = new Date(billing.fecha);
        let proccess: string = date.getFullYear().toString().slice(2, 4);
        proccess += ((date.getMonth() + 1) < 10) ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);

        return proccess === statesAccounts[0].value.slice(0, 4);
      });

      setBillingMatched(billingMatched1);
    }
  }, [billings, statesAccounts]);

  useEffect(() => {
    if (idCliente && !_.isEmpty(idCliente) && processStatement && !_.isEmpty(processStatement)) {
      const data = {
        sucursal: idCliente.substring(0, 3),
        suscriptor: idCliente.substring(3, 10),
        proceso: processStatement,
      };

      const encryptedData = cifrarAES(data, "5DCC67393750523CD165F17E1EFADD21");
      setImageUrl(`${appProps.BASE_URL}/statements/download-image/${encryptedData}`);
    }
  }, [idCliente, processStatement]);

  return (
    <>
      {
        ((isLoading) || (_.isNull(paymentData)) || (_.isNull(status))) ?
          <Loading />
          :
          <SubDefaultLayout
            title={sendSMS ? "Enviar Estado de Cuenta por SMS" : "Estado de Cuenta"}
            needReturn={sendSMS ? true : false}
            functionReturn={() => setSendSMS(false)}
          >
            {
              unavailableInfo || hasError ?
                <div style={{ marginTop: 10 }}>
                  <InfoCardComponent title="¡Atención!" description={message} />
                </div>
                :
                <>
                  {
                    sendSMS ?
                      <>
                        {
                          selectedDate ?
                            <SendSMS
                              selectDate={selectedDate}
                              statusChange={status}
                              statesAcc={statesAccounts[0]}
                              date={fullDateFormat}
                              dateProccess={`20${processStatement.slice(0, 2)}`}
                              sendSmsFnt={sendSmsFnt}
                            />
                            :
                            null
                        }
                      </>
                      :
                      <>
                        <div style={{ marginTop: 10 }}>
                          <InfoCardComponent
                            title="¡Atención!"
                            description="El saldo que se muestra en su estado de cuenta es al corte más los cargos adicionales que se hubieran realizado."
                          />
                        </div>
                        <Row gutter={[12, 12]} style={styles.rowPrincipal}>
                          <Col xs={24} xl={12}>
                            <Card
                              bodyStyle={{ justifyContent: "center" }}
                              style={{ ...styles.cardRoot }}
                            >
                              <Row style={{ display: "flex", justifyContent: "center" }}>
                                <div
                                  style={{
                                    ...styles.divRoot,
                                    backgroundColor: "#0055c2",
                                  }}
                                >
                                  <Col style={{ marginTop: 15, marginBottom: 10 }}>
                                    <Col>
                                      <Text style={styles.textPrincipal}>
                                        {nombre}
                                      </Text>
                                    </Col>
                                    <Col>
                                      <Text style={styles.textRegular}>
                                        Suscriptor: {idCliente}
                                      </Text>
                                    </Col>
                                    <Col>
                                      <Text style={styles.textRegular}>
                                        {generalData.selectedContract?.paquete}
                                      </Text>
                                    </Col>
                                  </Col>
                                </div>
                                <div style={styles.footerCard}>
                                  <Text style={styles.textDaysLimit}>Tu fecha de corte es el día <b>{fullDateFormat}</b></Text>
                                </div>
                              </Row>
                              <Row justify={"center"} style={{ marginTop: 15 }}>
                                <Col xs={8} xl={18}>
                                  <Text
                                    style={{
                                      color: "#0f5fb1",
                                      fontWeight: 600,
                                      fontSize: 16,
                                    }}
                                  >
                                    {
                                      selectedDate && processStatement && statesAccounts.length > 0 ?
                                        `20${processStatement.slice(0, 2)}`
                                        :
                                        ""
                                    }
                                  </Text>
                                </Col>
                              </Row>
                              <Row justify={"center"}>
                                <Col xs={8} xl={18}>
                                  <div style={styles.inputContainer}>
                                    <Text style={styles.inputTextTitle}>
                                      Mes
                                    </Text>
                                    <Select
                                      style={styles.inputText}
                                      placeholder="Seleccione un mes"
                                      notFoundContent="No se encontraron datos"
                                      defaultValue={statesAccounts[0]}
                                      onChange={(value, option) =>
                                        handleDateSelection(option)
                                      }
                                      options={statesAccounts.map((data) => ({
                                        value: data.value,
                                        label: data.label,
                                      }))}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                          <Col xs={24} xl={12}>
                            <Card style={{ ...styles.cardRoot2 }}>
                              <Row justify="space-around">
                                {
                                  !selectedPeriod || (statesAccounts[0] && _.isEqual(statesAccounts[0].value, selectedPeriod)) ?
                                    <Col
                                      span={12}
                                      style={{
                                        justifyContent: "center",
                                        display: "flex",
                                      }}
                                    >
                                      <Button
                                        style={{
                                          ...styles.buttonFinal,
                                          backgroundColor: "#00339d",
                                        }}
                                        onClick={handleSendSMS}
                                        type="primary"
                                      >
                                        Enviar por SMS
                                      </Button>
                                    </Col>
                                    :
                                    null
                                }
                                <Col
                                  span={12}
                                  style={{
                                    justifyContent: "center",
                                    display: "flex",
                                  }}
                                >
                                  <Button
                                    style={{ ...styles.buttonFinal }}
                                    type="primary"
                                    onClick={() =>
                                      downloadStatement(processStatement)
                                    }
                                  >
                                    Descargar
                                  </Button>
                                </Col>
                                {
                                  selectedDate ?
                                    <>
                                      {
                                        status && selectedDate.value === statesAccounts[0].value ?
                                          <Col
                                            span={12}
                                            style={{
                                              justifyContent: "center",
                                              display: "flex",
                                            }}
                                          >
                                            <Button
                                              style={{
                                                ...styles.buttonFinal,
                                                backgroundColor: "#167cff",
                                              }}
                                              type="primary"
                                              onClick={() => {
                                                navigate("/payments");
                                              }}
                                            >
                                              Pagar
                                            </Button>
                                          </Col>
                                          :
                                          <>
                                            {
                                              canDownloadBillingPDF ?
                                                <>
                                                  {
                                                    billingMatched !== undefined && hasBilling ?
                                                      <Col
                                                        span={12}
                                                        style={{
                                                          justifyContent: "center",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <Button
                                                          style={{
                                                            ...styles.buttonFinal,
                                                            backgroundColor: "#167cff",
                                                          }}
                                                          type="primary"
                                                          onClick={() =>
                                                            getBillingPDFFunction(
                                                              billingMatched
                                                            )
                                                          }
                                                        >
                                                          Factura
                                                        </Button>
                                                      </Col>
                                                      :
                                                      null
                                                  }
                                                </>
                                                :
                                                null
                                            }
                                          </>
                                      }
                                    </>
                                    :
                                    null
                                }
                              </Row>
                              <Image
                                width={"100%"}
                                src={imageUrl}
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src = images.statementNotAvailable;
                                }}
                                placeholder={
                                  <Image
                                    width={"100%"}
                                    src={images.statementLoading}
                                  />
                                }
                              />
                            </Card>
                          </Col>
                        </Row>
                      </>
                  }
                </>
            }
          </SubDefaultLayout>
      }
    </>
  );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
  rowPrincipal: {
    marginTop: 30,
    display: "flex",
  },
  cardRoot: {
    backgroundColor: "white",
    marginBottom: 15,
    boxShadow: "0px 0px 8px #00000029",
    borderRadius: 20,
  },
  cardRoot2: {
    backgroundColor: "white",
    marginBottom: 15,
    boxShadow: "0px 0px 8px #00000029",
    borderRadius: 20,
    minHeight: 800
  },
  divRoot: {
    width: "100%",
    borderRadius: 18,
    display: "flex",
    textAlign: "center",
    justifyContent: "center",
  },
  textPrincipal: {
    color: "white",
    fontSize: 18,
    fontWeight: 600,
  },
  textRegular: {
    color: "white",
    fontSize: 15,
  },
  footerCard: {
    display: "flex",
    width: "90%",
    padding: 5,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "0px 0px 20px 20px",
    backgroundColor: "#d9d9d9",
  },
  textDaysLimit: {
    color: "#000000",
    textAlign: "center",
    fontSize: 13,
  },
  textDateLimit: {
    color: "#000000",
    textAlign: "center",
    fontSize: 13,
    fontWeight: 600,
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "10px",
    marginLeft: "5px",
    marginRight: "5px",
  },
  inputTextTitle: {
    fontSize: 15,
    color: "#0f5fb1",
  },
  inputText: {
    borderRadius: 0,
    marginTop: 3,
    width: "100%",
  },
  buttonFinal: {
    backgroundColor: "#0055c2",
    borderRadius: 15,
    color: "white",
    boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
    marginBottom: 10,
    width: 140,
  },
  withOverdueColor: {
    color: "#e00614",
  },
  withoutOverdueColor: {
    color: "#0055c2",
  },
});

export default AccountState;
